import { suggestionPanelLoader } from '@rankers/components/suggestion_panel/suggestion_panel_loader';
suggestionPanelLoader();
